import { useSelector } from 'react-redux';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

import { useTransl } from 'shared/lib/i18n';

import { getBreadcrumbs } from './Breadcrumbs';
import { config, getRoutes } from './BreadcrumbsConfig';

const StyledTitle = styled(Grid)(() => ({
  margin: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
}));

const Breadcrumbs = () => {
  const { t } = useTransl();
  const location = useLocation();

  const state = useSelector((state) => state);

  const breadcrumbs = getBreadcrumbs({
    routes: getRoutes(t),
    location,
    options: config,
  });

  if (!breadcrumbs || breadcrumbs?.length === 0) {
    return null;
  }

  const formattedBreadcrumbs = breadcrumbs.map(({ breadcrumb, ...rest }) => {
    if (typeof breadcrumb === 'string') {
      return { title: breadcrumb, ...rest };
    }
    if (typeof breadcrumb === 'function') {
      const title = breadcrumb({ ...state, ...rest });
      return { title, ...rest };
    }
    return breadcrumb;
  });

  const pageTitle = formattedBreadcrumbs
    .map(({ title }) => title)
    .filter(Boolean)
    .join(' - ');

  if (document.title !== pageTitle) {
    document.title = pageTitle;
  }

  return (
    <StyledTitle container wrap="nowrap">
      {formattedBreadcrumbs.map(({ title, match, key }, i) => {
        if (!title || !match?.url) return null;

        const isLast = breadcrumbs.length - 1 === i;

        return (
          <span key={key}>
            {isLast ? (
              <span>{title}</span>
            ) : (
              <Link component={RouterLink} to={match?.url} color="primary">
                {title}
              </Link>
            )}
            {i + 1 < breadcrumbs.length ? <span>&nbsp;-&nbsp;</span> : null}
          </span>
        );
      })}
    </StyledTitle>
  );
};

export default Breadcrumbs;
